import { asString } from '../utils/dataGuards';

const ThridText = ({contact, color, background, link, url, supple=""}) => {
    const value = asString(contact).trim() || 'NA';
    if (link && value !== 'NA' && url) {
        return (
            <span style={{color: color, background: background, overflowWrap: 'break-word'}}>
                <a href={url + value + supple} style={{color: color}} target="_blank" rel="noreferrer">{value}</a>
            </span>
        )
    } else {
        return (
            <span style={{color: color, background: background, overflowWrap: 'break-word'}}>
                {value}
            </span>
        )
    }
}

export default ThridText
